import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M8.015 1a7 7 0 100 14 7 7 0 000-14zm-2 4c.559 0 1.032.473 1.032 1.031V7c0 .558-.473 1-1.032 1-.558 0-1-.442-1-1v-.97c0-.558.442-1.031 1-1.031zm4 0c.559 0 1 .473 1 1.031V7c0 .558-.441 1-1 1-.558 0-1-.442-1-1v-.97c0-.558.442-1.031 1-1.031zM3.603 7.719c.78 3.306 4.693 4.432 7.705 3.287.007.598-.195 1.097-1.154 1.286-2.166.426-5.161-.143-6.68-2.594-.666-1.074-.127-1.685.129-1.98z" fill="#474747" /></svg>;
}

export default SvgComponent;